module.exports = __webpack_public_path__ + "media/volvo/assets/images/gowashmycar@2x-7c95d96e01fb588e39349da7a2b36fb5.png";